import React from 'react';
import {
  CaseCreationStaticSchema,
  createCaseStaticSchema,
} from '../CreateCaseSchema';
import styled from 'styled-components';
import { Header } from 'src/react-jsonschema-katal';
import UserStaticInfoProvider from './context/UserStaticInfoContext';

import UserInformationContent from './helpers/UserInformationContent';

const UserStaticInformationLayout = styled.div``;

export interface UserStaticInformationProps {
  store?: {
    [attribute: string]: string;
  };
  schema: CaseCreationStaticSchema;
}

const UserStaticInformation: React.FC<UserStaticInformationProps> = ({
  store = {},
  schema,
}) => {
  return (
    <UserStaticInfoProvider store={store}>
      <UserStaticInformationLayout>
        {schema.title && <Header title={schema.title} />}
        <UserInformationContent properties={schema.properties} />
      </UserStaticInformationLayout>
    </UserStaticInfoProvider>
  );
};

export default UserStaticInformation;
